import { useEffect, useState } from "react"
import { useAppDispatch, useAppSelector } from "../../../../lib/redux/hooks"
import { PlusIcon } from "../../../../ui/icons/plus"
import { TrashIcon } from "../../../../ui/icons/trash"
import { ButtonComponent } from "../../../../ui/molecules/button/newButton"
import { FileInputComponent } from "../../../../ui/molecules/fileInput"
import { FileViewer } from "../../../../ui/molecules/fileViewer"
import { MadfarmStaticSelect } from "../../../../ui/molecules/select/newSelect/static"
import { PopupForm } from "../../../../ui/organisms/popupForm"
import { EPAttachmentGroupOptions, OptionType } from "../../../../utils"
import { AddAttachmentPopupEntry } from "../../popup/addAttachmentEntry"
import { EntryProtocolFileAndAttachmentRequestDTO } from "../dataService/dto"
import { ProtocolSuccessBanner } from "../protocolSuccessBanner"
import { addDefaultUpdateEPEntryAttachmentIds, addEPFileAndAtt, addUpdateEPEntryAttachmentId, EntryProtocolRemoveFile, GetAllEntryProtocolAttachments, resetEntryProtocolRemoveFileStatus, resetEPAttCreationRequest, resetGetAllEntryProtocolAttachmentsStatus, setEPFileAndAtt, setFileToUpdate, setUpdatedFile, setUpdateEPEntryAttachmentIds, setUpdateEPEntryAttachmentIdsByIndex } from "../slice"

export function EditEntryRight() {
    const dispatch = useAppDispatch()
    const entryProtocolState = useAppSelector(state => state.entryProtocol)
    const objectStorageState = useAppSelector(state => state.objectStorage)
    const userState = useAppSelector(state => state.users)
    const [showPopup, setShowPopup] = useState<boolean>(false)
    const [attachments, setAttachments] = useState<OptionType[]>([])
    const [groupValues, setGroupValues] = useState<string | null>(null)
    const [resetKey, setResetKey] = useState<number>(0)

    const documentUploadPredicate = (index: number, attId: string): boolean => {
        return entryProtocolState.entryProtocolUpdateFileAndAtt
            .find(obj => obj.attachmentId === attId) !== undefined ||
            attId === '' ||
            entryProtocolState.updatedEntryProtocolFileAndAtts?.find(obj => obj.attachmentId === attId) !== undefined
    }

    const NotAvailableAttachments = () => {
        return attachments.filter(att => entryProtocolState.entryProtocolUpdateRequest.entryAttachmentIds.includes(att.value))
    }

    useEffect(() => {
        dispatch(GetAllEntryProtocolAttachments({
            itemsPerPage: 0,
            page: 0
        }))
    }, [])

    useEffect(() => {
        if (entryProtocolState.getAllEntryProtocolAttachmentsStatus === 'successfully' &&
            entryProtocolState.getAllEntryProtocolAttachmentsResponse !== undefined
        ) {
            dispatch(resetGetAllEntryProtocolAttachmentsStatus())
            const data = entryProtocolState.getAllEntryProtocolAttachmentsResponse
            const newAtts: OptionType[] = data.data.map(d => {
                return { value: d.id, label: `${d.description} [${d.coding}]` } as OptionType
            })
            setAttachments(newAtts)
        }
    }, [entryProtocolState.getAllEntryProtocolAttachmentsStatus])

    useEffect(() => {
        if (entryProtocolState.entryProtocolRemoveFileStatus === 'successfully') {
            dispatch(resetEntryProtocolRemoveFileStatus())
            dispatch(setUpdatedFile(undefined))
        }
    }, [entryProtocolState.entryProtocolRemoveFileStatus])

    const handleOnDelete = (attId: string) => {
        const newAtts = entryProtocolState.entryProtocolUpdateRequest.entryAttachmentIds.filter(a => a !== attId)
        const newFilesAtts = entryProtocolState.entryProtocolUpdateFileAndAtt.filter(obj => obj.attachmentId !== attId)
        dispatch(setUpdateEPEntryAttachmentIds(newAtts))
        dispatch(setEPFileAndAtt(newFilesAtts))
    }


    const handleOnGroupSelect = (value: any) => {
        if (!value) return;

        let Ids: string[] = [];
        if (typeof value === 'string') {
            Ids = value.split('-');
        } else if (Array.isArray(value)) {
            Ids = value;
        } else if (value.value && typeof value.value === 'string') {
            Ids = value.value.split('-');
        } else {
            Ids = String(value).split('-');
        }

        for (const id of Ids) {
            if (id !== '' && !entryProtocolState.entryProtocolUpdateRequest.entryAttachmentIds.includes(id))
                dispatch(addUpdateEPEntryAttachmentId(id))
        }
    }

    return (
        <div className={"flex flex-col gap-6"}>
            <ProtocolSuccessBanner
                protocol={entryProtocolState.selectedProtocolNumber || ''}
                type='entry'
                bannerPlace='edit'
                closeAction={() => console.log()}
            />
            <div style={{ borderBottomWidth: 1 }}>
                <FileInputComponent
                    label="Aggiungi PDF"
                    id={"ep-edit-upload-add"}
                    key={"ep-edit-upload-add"}
                    infoText
                    fullHeight
                    permittedExtensions={['PDF']}
                    color={"green"}
                    onChange={(e) => {
                        dispatch(setFileToUpdate(e[0]))
                    }}
                />
                {
                    entryProtocolState.fileToUpdate && (
                        <div className="pt-3" style={{ display: 'flex', alignItems: 'center' }}>
                            <div style={{ flex: '0.9' }}>
                                <FileViewer
                                    toUpdate
                                    fileName={entryProtocolState.fileToUpdate.name}
                                    otherInfo={entryProtocolState.fileToUpdate.type}
                                />
                            </div>
                            <div className="cursor-pointer" style={{ display: 'flex', flex: '0.1', justifyContent: 'center' }}
                                onClick={() => dispatch(setFileToUpdate(null))}>
                                <TrashIcon size={20} color="dimgrey" />
                            </div>
                        </div>
                    )
                }
                {
                    entryProtocolState.updatedFile && (
                        <div className="pt-3" style={{ display: 'flex', alignItems: 'center' }}>
                            <div style={{ flex: '0.9' }}>
                                <FileViewer
                                    fileId={objectStorageState.getFileObjectByIdResponse?.id}
                                    toUpdate={false}
                                    fileName={entryProtocolState.updatedFile.name}
                                    otherInfo={entryProtocolState.updatedFile.type}
                                />
                            </div>
                            <div className="cursor-pointer" style={{ display: 'flex', flex: '0.1', justifyContent: 'center' }}
                                onClick={() => dispatch(EntryProtocolRemoveFile(entryProtocolState.entryProtocolIdToUpdate))}>
                                <TrashIcon size={20} color="dimgrey" />
                            </div>
                        </div>
                    )
                }
            </div>
            <span className="input-label" style={{ fontSize: '16px', fontWeight: 600 }}>
                Allegati
            </span>
            {
                entryProtocolState.entryProtocolUpdateRequest.entryAttachmentIds.map((att, index) => {
                    const newFile = entryProtocolState.entryProtocolUpdateFileAndAtt.find(obj => obj.attachmentId === att);
                    const existingFile = entryProtocolState.updatedEntryProtocolFileAndAtts?.find(obj => obj.attachmentId === att);

                    return (
                        <div key={`attachment-row-${index}`} className="w-full flex flex-col gap-3 p-4 bg-white border border-neutral-200 rounded-xl box-shadow-xs">
                            <div className="flex items-end gap-3 w-full">
                                <div className="flex-1">
                                    <MadfarmStaticSelect
                                        label="Aggiungi allegato (Singolo)"
                                        noOptionsMessage="Nessun allegato disponibile"
                                        value={att}
                                        placeholder={'Seleziona...'}
                                        disabledOptions={NotAvailableAttachments()}
                                        options={attachments}
                                        onChange={(value) => {
                                            //@ts-ignore
                                            dispatch(setUpdateEPEntryAttachmentIdsByIndex({ data: value !== null ? value.value : null, index: index }))
                                        }}
                                    />
                                </div>
                                <div className="flex items-center gap-2" style={{ paddingBottom: '2px' }}>
                                    <FileInputComponent
                                        id={`ep-edit-upload-add-${index}`}
                                        key={`ep-edit-upload-add-${index}`}
                                        iconSize
                                        color={"green"}
                                        disabled={documentUploadPredicate(index, att)}
                                        onChange={(e) => {
                                            dispatch(addEPFileAndAtt({ file: e[0], attachmentId: att } as EntryProtocolFileAndAttachmentRequestDTO))
                                        }}
                                    />
                                    <ButtonComponent
                                        variant="outline"
                                        color="gray"
                                        icon={<TrashIcon size={20} color="red" />}
                                        onClick={() => handleOnDelete(att)}
                                        iconPosition="only"
                                        size="md"
                                    />
                                </div>
                            </div>
                            {(newFile || existingFile) && (
                                <div className="flex flex-col gap-2 mt-1 pt-3 border-t border-neutral-100">
                                    {newFile && (
                                        <div className="w-full pl-1">
                                            <FileViewer
                                                smallSize
                                                toUpdate
                                                fileName={newFile.file.name!}
                                                otherInfo={newFile.file.type!}
                                            />
                                        </div>
                                    )}
                                    {existingFile && (
                                        <div className="w-full pl-1">
                                            <FileViewer
                                                fileId={existingFile.fileInfo.fileId!}
                                                smallSize
                                                fileName={existingFile.fileInfo.name!}
                                                otherInfo={existingFile.fileInfo.type!}
                                            />
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>
                    );
                })
            }
            <div className="pb-2 pt-3">
                <ButtonComponent
                    variant="outline"
                    color="blue"
                    iconPosition="left"
                    icon={<PlusIcon color="orange" size={16} />}
                    size="sm"
                    label="Nuovo allegato"
                    onClick={() => dispatch(addDefaultUpdateEPEntryAttachmentIds())}
                />
            </div>
            {
                userState.findMeResponse.role === 'admin' &&
                <div className='pb-5' style={{ display: 'flex', flex: 'wrap', gap: '24px', alignItems: 'center', justifyContent: 'flex-end' }}>
                    <ButtonComponent
                        variant="outline"
                        color="orange"
                        iconPosition="left"
                        icon={<PlusIcon color="orange" size={16} />}
                        size="sm"
                        label="Nuovo tipo di allegato"
                        onClick={() => setShowPopup(true)}
                    />
                </div>
            }
            <div className="border h-[1px] border-neutral-200" />
            <div style={{ display: 'flex', flexDirection: "row", gap: '16px', alignItems: 'center' }}>
                <MadfarmStaticSelect
                    key={`group-select-${resetKey}`}
                    label="Inserisci più allegati"
                    value={groupValues}
                    noOptionsMessage="Nessun allegato disponibile"
                    placeholder={'Seleziona...'}
                    options={EPAttachmentGroupOptions}
                    onChange={(value) => {
                        //@ts-ignore
                        setGroupValues(value !== null ? value.value : null)
                    }}
                />
                <div className="pt-5">
                    <ButtonComponent
                        variant="outline"
                        color="gray"
                        iconPosition="off"
                        size="md"
                        label="Allega"
                        onClick={() => {
                            handleOnGroupSelect(groupValues)
                            setGroupValues(null)
                            setResetKey(prev => prev + 1)
                        }}
                    />
                </div>
            </div>
            {
                showPopup && (
                    <PopupForm title='Aggiungi Allegato' close={() => {
                        dispatch(resetEPAttCreationRequest())
                        setShowPopup(false)
                    }}>
                        <AddAttachmentPopupEntry close={() => {
                            dispatch(resetEPAttCreationRequest())
                            setShowPopup(false)
                        }} />
                    </PopupForm>
                )
            }
        </div>
    )
}